import { memo, useCallback } from 'react';
import { IconTextStyleUnderline } from '../../../icons';
import { useTiptap } from '../Tiptap';
import { type Editor, useEditorState } from '@tiptap/react';
import TiptapToolbarButton from './tiptap-toolbar-button';

const TiptapUnderline = memo(() => {
  const { editor } = useTiptap();

  const editorState = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor }) => ({
      isUnderline: editor.isActive('underline'),
    }),
  });

  const onClick = useCallback(
    () => editor.chain().focus().toggleUnderline().run(),
    [editor],
  );

  return (
    <TiptapToolbarButton
      aria-label="souligner"
      tooltip="Souligner"
      icon={IconTextStyleUnderline}
      isActive={editorState.isUnderline}
      onClick={onClick}
    />
  );
});

TiptapUnderline.displayName = 'Tiptap.Toolbar.Underline';

export default TiptapUnderline;
